module.exports = new __parcel__URL__("bossfight_boss_legendary.5481bc52.png").toString();